import { FC, useCallback } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export interface CommitmentsTabSwitcherProps {
  tabs: { value: string; label: string }[];
  onTabChange(value: string): void;
  value: string;
  size?: "medium" | "small";
}
export const CommitmentsTabSwitcher: FC<CommitmentsTabSwitcherProps> = ({
  tabs,
  onTabChange,
  value,
  size,
}) => {
  const tabChangeHandler = useCallback(
    (_: unknown, tab: string | null) => {
      if (!tab) {
        return;
      }
      onTabChange(tab);
    },
    [onTabChange],
  );

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      sx={toggleButtonGroupSx}
      onChange={tabChangeHandler}
    >
      {tabs?.map((item) => {
        return (
          <ToggleButton
            key={item.value}
            value={item.value}
            sx={{
              ...toggleButtonSx,
              py: size === "small" ? 0.5 : undefined,
            }}
          >
            {item.label}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

const toggleButtonSx = {
  px: 1.5,
  "&.Mui-selected": {
    backgroundColor: "white",
    color: "primary.main",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "white",
    color: "primary.main",
  },
  "&:hover": {
    backgroundColor: "transparent",
  },
  border: 0,
};

const toggleButtonGroupSx = {
  borderRadius: 1.5,
  bgcolor: "grey.300",
  p: 0.25,
  border: 0,
  "& .MuiToggleButton-root": {
    marginLeft: 0,
    borderRadius: 1,
  },
  width: "fit-content",
};
